import StartList from './widgets/StartList';

/**
 * Every widget this bundle can render, keyed by the name in the host page's
 * `id="omnigo-<name>"` or `data-omnigo-widget="<name>"`.
 *
 * One bundle serves all of them, so adding a widget is a file under `widgets/`
 * plus a line here -- the script URL customers have already embedded does not
 * change.
 */
const registry = {
    'start-list': StartList
};

export default registry;
